import { render, staticRenderFns } from "./TermsOfSalesPage.vue?vue&type=template&id=1178aa04&scoped=true"
import script from "./TermsOfSalesPage.vue?vue&type=script&lang=js"
export * from "./TermsOfSalesPage.vue?vue&type=script&lang=js"
import style0 from "./TermsOfSalesPage.vue?vue&type=style&index=0&id=1178aa04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1178aa04",
  null
  
)

export default component.exports